export enum FormCaptchaType {
    Puzzle = 'Puzzle'
}

export type FormCaptchaPayload = {
    positionY: number;
    puzzleImageBytes: string;
    backgroundImageBytes: string;
}

export type FormCaptchaChallenge = {
    id: string;
    type: FormCaptchaType;
    expiresAt: string;
    payload: FormCaptchaPayload;
}
